import { all } from "redux-saga/effects";

import seoRedirectsSaga from "./seoRedirects/saga";

export default function* rootSaga() {
	yield all([seoRedirectsSaga()]);
}
